import { cva } from "class-variance-authority";

export const typographyVariants = cva("", {
  variants: {
    variant: {
      default: "",

      heading: "font-semibold tracking-tight",
      subtitle: "text-muted-foreground",
      caption: "text-muted-foreground",
      label: "font-medium leading-none",
      description: "text-muted-foreground",
      link: "text-primary underline-offset-4 hover:underline",
      error: "text-destructive",
      success: "text-green-600",
      warning: "text-yellow-600",
      muted: "text-muted-foreground",
      secondary: "text-gray-600",
      neutral: "text-neutral-600",
    },
    size: {
      xs: "text-xs",
      sm: "text-sm",
      base: "text-base",
      lg: "text-lg",
      xl: "text-xl",
      "2xl": "text-2xl",
      "3xl": "text-3xl",
      "20px": "text-[20px]",
    },
    weight: {
      normal: "font-normal",
      medium: "font-medium",
      semibold: "font-semibold",
      bold: "font-bold",
    },
    color: {
      default: "",
      primary: "text-primary",
      secondary: "text-gray-600",
      neutral: "text-neutral-600",
      muted: "text-muted-foreground",
      destructive: "text-destructive",
      success: "text-green-600",
      warning: "text-yellow-600",
      lighterBlue: "text-ticketon-lighter-blue",
      white: "text-white",
      gray900: "text-gray-900",
      gray800: "text-gray-800",
      gray700: "text-gray-700",
      gray600: "text-ticketon-gray-600",
      gray500: "text-gray-500",
      darkBlue: "text-ticketon-dark-blue",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "base",
    weight: "normal",
    color: "default",
  },
});
